module.exports = __webpack_public_path__ + "public/img/anlithree.e2da704a.gif";